import { render, staticRenderFns } from "./ManageIpBlacklist.vue?vue&type=template&id=ce3e3398"
import script from "./ManageIpBlacklist.vue?vue&type=script&lang=js"
export * from "./ManageIpBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports